import { Meal } from '@akin-home/meals';
import { useGetRecipe } from '@akin-home/recipes/react';
import { Image, ImageStyle, StyleProp } from 'react-native';
import useRecordImage from '../../images/hooks/useRecordImage';
import { recipe_thumbnail_image_edits } from '../../recipes/data/image_params';

interface Props {
  meal: Meal;
  style?: StyleProp<ImageStyle>;
}

export const MealImage = (props: Props) => {
  const id = props.meal.recipes[0]?.id;

  const { data: recipe } = useGetRecipe({ id });

  const { uri } = useRecordImage({
    record: recipe,
    edits: recipe_thumbnail_image_edits,
  });

  return uri ? <Image style={props.style} source={{ uri }} /> : null;
};
